module.exports = __webpack_public_path__ + "static/img/scash-btn.afd684d.png";